import * as React from 'react';
import { Empty } from "antd";
import { MultipleSelectTableProps, MultipleSelectWithTableValue } from "./MultipleChoicesWithTable";
import Table from 'antd/es/table';
import Button from "antd/es/button";

export default function MultipleChoicesTable(props: MultipleSelectTableProps) {
  const { dataSource, onRemove } = props;

  if (!dataSource) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return <Table dataSource={dataSource} columns={[
    {
      title: 'ID',
      render: (record: MultipleSelectWithTableValue) => {
        return record.value;
      }
    },
    {
      title: 'Name',
      render: (record: MultipleSelectWithTableValue) => {
        return record.label;
      }
    },
    {
      title: 'Actions',
      render: (record: MultipleSelectWithTableValue) => {
          return <Button type={'link'} onClick={() => onRemove && onRemove(record)}>
            remove
          </Button>
      }
    }
  ]}/>
}